export default {
  password: "auth/set-password",
  notification: "auth/notification",
  checkStatusUpdate: "application/checkStatusUpdate",
  CERTIFICATE_OF_GOOD_STANDING: (code) =>
    `license/good_standing_certificate/${code}`,
};
